module.exports = __webpack_public_path__ + "static/img/homeright41.0088049.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/image/homeright41.png
// module id = s3Tx
// module chunks = 13